// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__27B5l","amount":"Amount_amount__JLUWs","tip":"Amount_tip__XitOm","tipHeader":"Amount_tipHeader__VLNej","tipsWrap":"Amount_tipsWrap__2B3ZO"};